import {Enum} from '../../common/model/enum.model';

export class StatoRuoloPersona extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): StatoRuoloPersona[] {
    return [
        new StatoRuoloPersona('P'),
        new StatoRuoloPersona('D'),
        new StatoRuoloPersona('E')
    ];
  }

  public getLabelValue() {
    return 'stato.ruolo.persona.' + this.value;
  }


}
